// ShopCard.jsx
import React, { useContext } from "react";
import { Star } from "lucide-react";
import "../../../assets/css/customer/components/ShopCard.css";
import AppContext from "../../../contexts/AppContext";

const ShopCard = ({ shop, onViewShop }) => {
  const { baseUrlForFiles } = useContext(AppContext);

  return (
    <div className="shop-card" onClick={() => onViewShop(shop)}>
      <div className="shop-card-image">
        <img
          src={
            shop.shop_image
              ? `${baseUrlForFiles}/${shop.shop_image}`
              : "/default-shop.png"
          }
          alt={shop.name}
        />
      </div>

      <div className="shop-card-content">
        <h3 className="shop-card-name">{shop?.name}</h3>
        <p className="shop-card-city">{shop?.city}</p>
        <p className="shop-card-description">{shop?.description}</p>

        <div className="shop-card-footer">
          <div className="shop-rating">
            <Star size={16} fill="#ffc107" color="#ffc107" />
            <span>
              {shop.reviews_avg_rating
                ? parseFloat(shop.reviews_avg_rating)
                    .toFixed(1)
                    .replace(".0", "")
                : "0"}
            </span>
          </div>
          <div className="shop-products">
            <span>{shop.products_count || 0} Products</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopCard;
